import React from "react";
import secureLocalStorage from "react-secure-storage";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Layouts/Sidebar";
import BirthdayAnimation from "./Screens/Home/BirthdayAnimation";

const PrivateComponent = () => {
  const [isChecking, setIsChecking] = React.useState(true);
  const [auth, setAuth] = React.useState(null);

  React.useEffect(() => {
    // Park any chat invite token from the URL BEFORE the auth redirect strips it.
    // If the user isn't logged in they'll be redirected to /, losing the query string.
    // Saving to localStorage here means ChatModal's navigation effect can still find
    // and process it after the user logs in.
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get("chat_invite");
    if (inviteToken) {
      localStorage.setItem("planit_pending_chat_invite", inviteToken);
      window.history.replaceState({}, "", window.location.pathname);
    }

    // Initial check
    const currentAuth = JSON.parse(secureLocalStorage.getItem("adminInfo"));

    if (currentAuth) {
      setAuth(currentAuth);
      setIsChecking(false);
    } else {
      // Small grace period for storage synchronization/decryption on mount
      const timer = setTimeout(() => {
        const finalAuth = JSON.parse(secureLocalStorage.getItem("adminInfo"));
        setAuth(finalAuth);
        setIsChecking(false);
      }, 100); // 100ms is usually enough to settle storage races
      return () => clearTimeout(timer);
    }
  }, []);

  if (isChecking) {
    return null; // Or a simple spinner
  }

  return auth ? (
    <>
      <BirthdayAnimation />
      <Sidebar />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateComponent;
